import React from "react";
import { Alert } from "react-bootstrap";
import { bool, string, object, oneOfType, node } from "prop-types";

const AlertBanner = ({
  alertType,
  bannerColor,
  bannerText,
  borderStyle = "",
  fontSize = "14px",
  iconInfo,
  marginBottom = "",
  noMarginBottom = false,
  textColor,
}) => {
  const { iconSrc, iconHeight, iconWidth } = iconInfo;
  return (
    <Alert
      style={{
        color: textColor,
        background: bannerColor,
        border: borderStyle,
        marginBottom,
        padding: "16px",
        fontSize,
      }}
      className={`d-flex ${noMarginBottom ? "mb-0" : ""}`}
    >
      <div>
        <img
          alt={alertType}
          src={iconSrc}
          height={iconHeight}
          width={iconWidth}
          className="mr-3"
        />
      </div>
      <div className="flex-grow-1">{bannerText}</div>
    </Alert>
  );
};

AlertBanner.propTypes = {
  alertType: string,
  bannerColor: string,
  bannerText: oneOfType([string, node]),
  borderStyle: string,
  fontSize: string,
  iconInfo: object,
  marginBottom: string,
  noMarginBottom: bool,
  textColor: string,
};

export default AlertBanner;
